import { render, staticRenderFns } from "./Growth.vue?vue&type=template&id=9530a03e&scoped=true&"
import script from "./Growth.vue?vue&type=script&lang=js&"
export * from "./Growth.vue?vue&type=script&lang=js&"
import style0 from "./Growth.scss?vue&type=style&index=0&id=9530a03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9530a03e",
  null
  
)

export default component.exports